/** User profile as returned by the login session. */
export interface User {
  id: number;
  email: string;
  nickname: string;
  avatarUrl: string;
  inviteCode: string;
  role: string;
  status: string;
  adminPermissions: string[];
}

/** Raw session DTO from POST /v1/auth/login.
 *  Backend Go struct has no json tags — fields are PascalCase. */
export interface SessionDTO {
  AccessToken: string;
  ExpiresAt: string;
  User: {
    ID: number;
    Email: string;
    Nickname: string;
    AvatarURL: string;
    InviteCode: string;
    Role: string;
    Status: string;
    AdminPermissions?: string[];
  };
}

/** User profile DTO from GET /v1/users/me (note: no role field). */
export interface UserMeDTO {
  id: number;
  email: string;
  nickname: string;
  avatar_url: string;
  status: string;
  invite_code: string;
  has_inviter: boolean;
  wallet?: {
    balance_fen: number;
    balance_yuan: string;
    frozen_fen: number;
    frozen_yuan: string;
    total_earned_fen: number;
    total_earned_yuan: string;
    total_withdrawn_fen: number;
    total_withdrawn_yuan: string;
    currency: string;
  };
}

export interface ApiError {
  status: number;
  message: string;
}

export function isApiError(e: unknown): e is ApiError {
  return (
    typeof e === 'object' &&
    e !== null &&
    'status' in e &&
    'message' in e
  );
}
